document.addEventListener('DOMContentLoaded', function () {
    const youtubeIframeContainers = document.getElementsByClassName('iframeYoutubeLoader')

    Array.from(youtubeIframeContainers).forEach((youtubeIframeContainer) => {
        $(youtubeIframeContainer).on('show.bs.collapse', function (event) {
            let iframe = this.children[0].children[0]
            iframe.src = iframe.getAttribute('data-src')
        })
    })
})
